import { render, staticRenderFns } from "./BDXPendingColumnFilter.vue?vue&type=template&id=0d076f2e&scoped=true"
import script from "./BDXPendingColumnFilter.vue?vue&type=script&lang=js"
export * from "./BDXPendingColumnFilter.vue?vue&type=script&lang=js"
import style0 from "./BDXPendingColumnFilter.vue?vue&type=style&index=0&id=0d076f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d076f2e",
  null
  
)

export default component.exports